export { default } from './hashString'
export * from './hashString'
